import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-radio-buttons',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './radio-buttons.component.html',
    styleUrl: './radio-buttons.component.css'
})
export class RadioButtonsComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  value: string | null = null;
  selectedOptionId: string | null = null;
  @Output() valueChange = new EventEmitter<any>();
  portError: any;
  ngOnInit() {
    const control = this.formGroup.get(this.fields.fieldName);

    if (control && !control.value) {
      control.setValue('443');
      this.selectedOptionId = '443';
    } else {
      this.selectedOptionId = control?.value === '443' ? '443' : 'other';
    }
  }

  onRadioChange(option: any) {
    this.selectedOptionId = option.id;

    if (!option.isCustomInput) {
      this.formGroup.get(this.fields.fieldName)?.setValue(option.id);
    } else {
      this.formGroup.get(this.fields.fieldName)?.setValue('');
    }
  }

  onCustomInputChange(event: any) {
    const raw = event.target.value.replace(/\D/g, '');
    event.target.value = raw;

    if (!raw) {
      this.portError = 'Port is required';
      this.formGroup.get(this.fields.fieldName)?.setValue('');
      return;
    }

    const num = Number(raw);

    if (num < 1 || num > 65535) {
      this.portError = 'Port must be between 1 and 65535';
      this.formGroup.get(this.fields.fieldName)?.setValue('');
      return;
    }

    // ✅ valid
    this.portError = null;
    this.formGroup.get(this.fields.fieldName)?.setValue(raw);
  }

  onKeyDown(event: KeyboardEvent) {
    const invalidKeys = ['e', 'E', '+', '-', '.', ' '];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pasted) || Number(pasted) > 65535) {
      event.preventDefault();
    }
  }
}
